import React from 'react';

import { Paper, Grid, FormControlLabel, Checkbox } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles( (mainTheme) => ({
  textCheckboxStyle:{
    color:mainTheme.palette.primary.main,
    margingLeft:"20px",
    marginRight: "5px",
    paddingRight: "2px",
    fontSize:"9px"
  },  
  input: {
    // height: "20px",
    boxSizing: "border-box" //
  }
}));

export default function CheckboxEstimateJustCashFlow  ({isEstimateFcffOnly, setIsEstimateFcffOnly, isDisabledChkBox, isClickable}) {
  const classes = useStyles();

  const handleChangeChkBox = () => {
  if (isClickable){
    if (isEstimateFcffOnly) {
      setIsEstimateFcffOnly(false);
    } else {
      setIsEstimateFcffOnly(true);
    }  
  }  

  };
  
  return (
  <>
  <Paper elevation = {3}>
    <Grid container>
      <Grid item>
        <FormControlLabel 
          className = {classes.textCheckboxStyle}
          disabled = {isDisabledChkBox}
          control = {<Checkbox disableRipple style={{ paddingLeft: '20px' }} defaultChecked = {false} checked = {isEstimateFcffOnly} size = "small"/>} 
          label = "Estimate only Free Cash Flow & Perpetuity Growth"
          onChange = {handleChangeChkBox}
        />
      </Grid>
    </Grid>
  </Paper>
  </>
  )
}
